import { authInstance as axios } from 'utils/axiosInterceptor';

const fetchVATRates = async () =>
  axios.get(`${process.env.REACT_APP_VAT_URL}/vatrates`);

export default { fetchVATRates };
